import Backend from 'shared/lib/Backend';

const dispatchStartSaving = dispatch => dispatch({ type: 'START_SAVING' });
const dispatchFinishSaving = dispatch => dispatch({ type: 'FINISH_SAVING' });

export default (id) => async (dispatch, getState) => {
  const { id, style_attributes } = getState().theme;
  dispatchStartSaving(dispatch);
  const body = JSON.stringify({ theme_id: id, theme: style_attributes });
  const response = await Backend.requestJson(`${window.location.pathname}/update_theme`, { body }, "PUT");
  dispatchFinishSaving(dispatch);
};

